import { Button, Container, Modal } from "react-bootstrap"
import DocumentRequestComponent from "../../../components/DocumentRequestComponent";
import { useState } from "react";
import { runInnerFunction } from '../../../../../compatManager';
import { DocumentRequestsModel } from "../../../types";


export type DocumentRequestModalProps = {
    showModal: boolean;
    onHideModal: () => void;
}

const DocumentRequestModal = (props: DocumentRequestModalProps) => {

    const [documentRequest, setDocumentRequests] = useState<DocumentRequestsModel>([]);
    const [docRequestSubmitted, setDocRequestSubmitted] = useState<boolean>(false);
    const [addRow, setAddRow] = useState<boolean>(false);

    const handleDocumentRequest = async () => {
        // remove any empty documentName values
        setDocRequestSubmitted(true)
        if (documentRequest.length !== 0) {
            for (var i = 0; i < documentRequest.length; i++) {
                if (documentRequest[i].documentName === '') {
                    documentRequest.splice(i, 1);
                }
            }
        }
        try {
            const resp = await runInnerFunction('ClientPortalUpdateAndSaveFile', { 'documentRequest': removeDuplicateDocumentNames(documentRequest) });
            if (resp) { setDocRequestSubmitted(false); }
        } catch (e) {
            console.log('Unable to get Document Requests: ', e)
        }
    }

    return (
        <Modal
            show={props.showModal}
            onHide={props.onHideModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title >Request Documents From Client(s)</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Container>
                    <DocumentRequestComponent
                        setDocumentRequests={setDocumentRequests}
                        addRow={addRow}
                        setAddRow={setAddRow}
                    />
                </Container>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={() => { props.onHideModal() }} variant='outline-primary'>Cancel</Button>
                <Button onClick={() => { setAddRow(!addRow) }} variant='outline-primary'>Add Row</Button>
                <Button
                    onClick={async () => {
                        await handleDocumentRequest();
                        props.onHideModal();
                    }}
                    disabled={docRequestSubmitted}
                >
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    )
}



export default DocumentRequestModal;

const removeDuplicateDocumentNames = (data: DocumentRequestsModel): DocumentRequestsModel => {
    const uniqueDocuments = new Set(); // Keep track of unique document names
    const result = []; 

    data.forEach(item => {
        const documentName = item.documentName.toLowerCase(); 

        if (!uniqueDocuments.has(documentName)) {
            uniqueDocuments.add(documentName);
            result.push(item);
        }
    });
    return result;
}
